export default "__VITE_ASSET__aff44e21__"